import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navegacion from "./components/Navegacion"
import Login from './components/Login';
import ActualizarPassword from './components/ActualizarPassword';
import RestablecerPassword from './components/RestablecerPassword';
import PrivateRoutes from './components/PrivateRoutes';
import { Container } from '@mui/system';
import Menu from './components/Menu';
import Logout from './components/Logout';
import AlumnoNuevoIngreso from './components/AlumnoNuevoIngreso';
import EstablecerPassword from './components/EstablecerPassword';
import Timer from './components/Timer';

export default function App() {
  return (
    <BrowserRouter>
      <Navegacion />
      <Timer/>
      <Container>
        <Routes>
          <Route element={<PrivateRoutes />}>           
            <Route path='/' element={<Menu />} />  
          </Route>
          <Route path='/auth/login' element={<Login />} />
          <Route path='/logout' element={<Logout />} />
          <Route path='/auth/restablecerPassword' element={<RestablecerPassword />} />
          <Route path='/auth/registroAlumno' element={<AlumnoNuevoIngreso />} />
          <Route path='/auth/actualizarPassword' element={<ActualizarPassword />} />
          <Route path='/auth/establecerPassword' element={<EstablecerPassword />} />
        </Routes>
      </Container>
    </BrowserRouter>
  );
}